module.exports = __webpack_public_path__ + "static/img/timer.ebc26a56.svg";